import React from 'react';
export function StatsBar() {
  return <div className="border-y border-zinc-800 bg-surface/50 py-6" data-id="element-324">
      <div className="max-w-5xl mx-auto px-4 flex flex-wrap justify-center md:justify-between gap-6 md:gap-4 text-center md:text-left" data-id="element-325">
        <div className="w-[45%] md:w-auto" data-id="element-326">
          <div className="text-2xl md:text-3xl font-space-grotesk font-bold text-white" data-id="element-327">
            +500
          </div>
          <div className="text-zinc-400 text-sm" data-id="element-328">profes confían</div>
        </div>
        <div className="w-[45%] md:w-auto" data-id="element-329">
          <div className="text-2xl md:text-3xl font-space-grotesk font-bold text-white" data-id="element-330">
            6 Tomos
          </div>
          <div className="text-zinc-400 text-sm" data-id="element-331">listos para usar</div>
        </div>
        <div className="w-[45%] md:w-auto" data-id="element-332">
          <div className="text-2xl md:text-3xl font-space-grotesk font-bold text-white" data-id="element-333">
            6 Bonos
          </div>
          <div className="text-zinc-400 text-sm" data-id="element-334">incluidos gratis</div>
        </div>
        <div className="w-[45%] md:w-auto" data-id="element-335">
          <div className="text-2xl md:text-3xl font-space-grotesk font-bold text-white" data-id="element-336">
            4.9/5
          </div>
          <div className="text-yellow-400 text-sm" data-id="element-337">⭐⭐⭐⭐⭐</div>
        </div>
      </div>
    </div>;
}